import { render, staticRenderFns } from "./TeamCreationWarningModal.vue?vue&type=template&id=6f638f16&scoped=true"
import script from "./TeamCreationWarningModal.vue?vue&type=script&lang=js"
export * from "./TeamCreationWarningModal.vue?vue&type=script&lang=js"
import style0 from "./TeamCreationWarningModal.vue?vue&type=style&index=0&id=6f638f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f638f16",
  null
  
)

export default component.exports